<script setup>
const props = defineProps(['field', 'modelValue'])
const emit = defineEmits(['update:modelValue'])
</script>

<template>
<v-text-field
	:label="field.label"
	:model-value="modelValue"
	hide-details="auto"
	type="date"
	@update:model-value="(val) => emit('update:modelValue', val)"
/>
</template>

<style lang="scss" scoped>

</style>